import { useLocation } from 'react-router-dom';
import { useSession } from '../contexts/SessionContext';

/**
 * Which side of the marketplace the current screen belongs to.
 * The route wins over the demo viewer prop, so /chef/* is always the chef experience.
 */
export function useViewerRole(): 'chef' | 'customer' {
  const { pathname } = useLocation();
  const { viewer } = useSession();
  if (pathname.startsWith('/chef')) return 'chef';
  if (pathname.startsWith('/app')) return 'customer';
  return viewer === 'chef' ? 'chef' : 'customer';
}
